import axios from 'axios'
import React, { useEffect, useState } from 'react'
import {baseUrl} from '../baseUrl'

const ContactUs = () => {
    const [name,setName]=useState('')
    const [email,setEmail]=useState('')
    const [subject,setSubject]=useState('')
    const [message,setMessage]=useState('')
    const [resp,setResp]=useState(false)
    const handleSend=(e)=>{
        e.preventDefault()
        if(name===''||email===''||subject===''||message===''){
            setResp('Please make sure you enter all details')
        }else{
            axios.post(`${baseUrl}/contact/send-mail`,{name,email,subject,message})
            .then(res=>{
                setResp(res.data.msg);
                setName('');
                setEmail('');
                setSubject('');
                setMessage('')
            })
            .catch(err=>console.log(err))
        }
    }
    useEffect(() => {
        const timer = setTimeout(() => {
          setResp(false); // Hide the alert after 3 seconds
        }, 4000);
    
        // Cleanup the timer if the component is unmounted before timeout
        return () => clearTimeout(timer);
      }, [resp]);
    return (
        <div>
            <section className="contact-info section-padding">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading">
                                <span className="subheading">Contact Us</span>
                                <h3>Have any query?</h3>
                                <p>Contact us to get your query resolved</p>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-12 col-md-6">
                                    <div className="contact-item">
                                        <p>Email Us</p>
                                        <h4>info@monarchinstitute.in</h4>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6">
                                    <div className="contact-item">
                                        <p>Make a Call</p>
                                        <h4>(+91) 9136431685</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-8">
                            <form className="contact__form form-row" onSubmit={handleSend} id="contactForm">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input value={name} onChange={(e)=>setName(e.target.value)} type="text" id="name" name="name" className="form-control" placeholder="Your Name" />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input value={email} onChange={(e)=>setEmail(e.target.value)} type="text" name="email" id="email" className="form-control" placeholder="Email Address" />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <input value={subject} onChange={(e)=>setSubject(e.target.value)} type="text" name="subject" id="subject" className="form-control" placeholder="Subject" />
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <textarea value={message} onChange={(e)=>setMessage(e.target.value)} id="message" name="message" cols="30" rows="6" className="form-control" placeholder="Your Message"></textarea>
                                        </div>
                                    </div>
                                </div>
                                    <div className="col-lg-6">
                                        {resp&&<div className="alert alert-success contact__msg" role="alert">
                                            {resp}
                                        </div>}
                                    </div>
    
                                <div className="col-lg-6">
                                    <div className="mt-4 text-right">
                                        <button className="btn btn-main" onClick={handleSend} type="submit">Send Message <i className="fa fa-angle-right ml-2"></i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ContactUs
